import React from "react";
import { SECTIONS } from "../../Utils/whatsNew";

// One "What's new" post as customers see it. Used by the sidebar (WhatsNew.jsx) and as the
// live preview in the admin editor (Administration/WhatsNewAdmin.jsx).

const BLUE = "#296AFF";
// Only full web addresses are shown (also in the admin preview, before the server checks them).
const isWebAddress = (url) => typeof url === "string" && /^https?:\/\/\S+$/i.test(url.trim());

/** One post: headline, picture, message, button and the lists of changes. Also the admin preview. */
export default function WhatsNewPostView({ post }) {
  if (!post) return null;
  return (
    <div>
      {isWebAddress(post.imageUrl) && (
        <img
          src={post.imageUrl}
          alt=""
          style={{ display: "block", width: "100%", maxHeight: 200, objectFit: "cover", borderRadius: 10, marginTop: 16 }}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      )}
      {post.title && <div style={{ fontSize: 17, fontWeight: 600, marginTop: 16, lineHeight: 1.35 }}>{post.title}</div>}
      {post.message && (
        <p style={{ fontSize: 14, lineHeight: 1.55, color: "#5b6476", margin: "8px 0 0", whiteSpace: "pre-line" }}>{post.message}</p>
      )}
      {isWebAddress(post.linkUrl) && (
        <a
          href={post.linkUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            marginTop: 12,
            padding: "7px 14px",
            borderRadius: 8,
            border: "1px solid " + BLUE,
            color: BLUE,
            fontSize: 13,
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          {post.linkText || "Learn more"}
          <span className="material-icons" style={{ fontSize: 16 }}>
            open_in_new
          </span>
        </a>
      )}
      {SECTIONS.filter((s) => post[s.key] && post[s.key].length).map((s) => (
        <section key={s.key} style={{ marginTop: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>{s.label}</div>
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {post[s.key].map((item, i) => (
              <li key={i} style={{ fontSize: 14, lineHeight: 1.55, color: "#5b6476", marginBottom: 8 }}>
                {item.title && <span style={{ fontWeight: 600, color: "#1d2433" }}>{item.title}{item.text ? ":" : ""}</span>}{" "}
                {item.text}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
